import "./promotion_info.css";
